import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    height: 50vh;
    align-items: center;
    justify-content: center;
    .icon{
        font-size: 3rem;
    }
`;